import { useContext } from 'react';

import { PokCoreContext } from '../pokCore';

export const usePokCore = () => useContext(PokCoreContext);
